// MVA og eiendeler (en).
window.PlummeI18n.register('en', {
  // -------------------------------------------------------- VAT return (vat)
  // Skatteetaten, Altinn and the RF-form numbers stay as proper nouns — they
  // name a real Norwegian authority or form the user has to recognise.
  'vat.term': 'VAT period',
  'vat.termHelp': 'A VAT period is the span you report VAT for. Most businesses file every other month - 6 periods a year. For each period, output and input VAT are totalled, and the difference is paid to or refunded by the state.',
  'vat.termShort': 'period',
  'vat.deadline': 'DEADLINE',
  'vat.amountHelp': 'VAT to pay means you owe the state because output VAT was larger than input VAT. VAT refundable means you get money back because you paid more VAT on purchases than you collected on sales.',
  'vat.openReturn': 'Open return',
  'vat.sortHelp': 'The periods are sorted by status: Needs action must be filed now, Upcoming are future periods, and Earlier are already filed or paid.',
  'vat.noTerms': 'No VAT periods yet',
  'vat.incompleteBasisTitle': 'The VAT basis is incomplete',
  'vat.incompleteBasisText': 'The VAT return is not presented as complete because journal coverage has not been documented. Document calculations remain available for diagnostics, not as a complete accounting basis.',
  'vat.needsAction': 'Needs action',
  'vat.upcoming': 'Upcoming',
  'vat.earlier': 'Earlier',
  'vat.toPay': 'VAT to pay',
  'vat.toPayHelp': 'Total outstanding VAT where output VAT is larger than input VAT.',
  'vat.paidIn': 'Paid',
  'vat.paidInHelp': 'VAT payments you have registered against periods in Plumme.',
  'vat.refunded': 'Refunded',
  'vat.refundedHelp': 'VAT refunds you have registered against periods in Plumme.',
  'vat.perTerm': 'Per period',
  'vat.returnStatus': 'VAT return status',
  'vat.period': 'Period',
  'vat.due': 'Deadline',
  'vat.calculated': 'Calculated settlement',
  'vat.settlement': 'Settlement',
  'vat.cancelPayment': 'Cancel payment',
  'vat.date': 'Date',
  'vat.amount': 'Amount',
  'vat.reference': 'Reference',
  'vat.referencePh': 'E.g. online bank, OCR',
  'vat.payments': 'Payments',
  'vat.paymentsHelp': 'An overview of payments registered against this VAT period.',
  'vat.noPayments': 'No payments registered',
  'vat.fromAccount': 'From account',
  'vat.edit': 'Edit',
  'vat.cancel': 'Cancel',
  'vat.cancelPaymentTitle': 'Cancel payment?',
  'vat.cancelPaymentConfirm': 'Yes, cancel the payment',
  'vat.backToTerms': 'Back to periods',
  'vat.importedBasisTitle': 'Imported from another accounting system',
  'vat.importedBasisHelp': 'The figures were imported as a basis. You can create, file and, if needed, cancel the VAT return using the ordinary workflow.',
  'vat.outputVat': 'Output VAT',
  'vat.outputVatHelp': 'VAT you have collected on sales in the period.',
  'vat.inputVat': 'Input VAT',
  'vat.inputVatHelp': 'Deductible VAT you have paid on purchases in the period.',
  'vat.netVat': 'Net VAT',
  'vat.netHelp': 'Output minus input VAT. A positive amount is paid, a negative amount is refundable.',
  'vat.checkStatus': 'Check status',
  'vat.checkStatusHelp': 'Shows the status Plumme has stored for the VAT return. Automatic status from Altinn or Skatteetaten is not connected in this Plumme surface yet.',
  'vat.seePayment': 'View payment',
  'vat.seePaymentHelp': 'See the payments registered against this VAT period — date, account, amount and reference.',
  'vat.codeOverview': 'Code overview for filing',
  'vat.codeOverviewHelp': 'The VAT return is built from standardised VAT codes from Skatteetaten. Each code collects one particular kind of sale or purchase. The basis is the amount excluding VAT. For reverse charge, both output and input VAT are shown even when the net amount is zero. Tap a code to see what belongs there.',
  'vat.codeTapHint': 'Tap a code to see what belongs there.',
  'vat.code': 'Code',
  'vat.description': 'Description',
  'vat.basis': 'Basis',
  'vat.rate': 'Rate',
  'vat.vat': 'VAT',
  'vat.calculatedFrom': 'Calculated from what you have registered in the app',
  'vat.delete': 'Delete',
  'vat.annulCustoms': 'Annul',
  'vat.annulled': 'Annulled',
  'vat.showAnnulledCustoms': 'Show annulled',
  'vat.showActiveCustoms': 'Show active',
  'vat.customsAnnulled': 'Customs declaration annulled',
  'vat.customsAnnulFailed': 'Could not annul the customs declaration.',
  'vat.registerCustoms': 'Register customs declaration',
  'vat.customsHelp': 'Enter a customs declaration for goods you have imported. Plumme calculates import VAT from the statistical value and puts it on the right code in the return.',
  'vat.flowHelp': 'Check the figures from the posted vouchers. Plumme cannot send the VAT return: you file it in the Skatteetaten service and then mark the period as filed outside Plumme here. You can then record the payment. The filed status can be removed again if it was set by mistake.',
  'vat.filing.statusFiled': 'Filed outside Plumme',
  'vat.filing.statusFiledPaid': 'Filed outside Plumme and paid',
  'vat.filing.statusNotFiled': 'Not marked as filed',
  'vat.filing.reviewFigures': 'Check the figures',
  'vat.filing.reviewedToast': 'Figures checked. File the VAT return with Skatteetaten.',
  'vat.filing.markOutside': 'Mark as filed outside Plumme',
  'vat.filing.clearStatus': 'Remove filed status',
  'vat.filing.dialogTitle': 'File the VAT return with Skatteetaten',
  'vat.filing.cannotSend': 'Plumme cannot send or sign the VAT return. You file it yourself with Skatteetaten, and mark the period as filed here afterwards.',
  'vat.filing.step1': 'Open the VAT return in the Skatteetaten service and enter the figures for this period from Plumme.',
  'vat.filing.step2': 'Submit and sign the return there, and keep the receipt.',
  'vat.filing.step3': 'Mark the period as filed outside Plumme here. You can then record the payment, and the period counts as filed in the year-end closing.',
  'vat.filing.termNotEnded': 'The period has not ended yet. The VAT return can only be filed after the period ends.',
  'vat.filing.filedDate': 'Date filed',
  'vat.filing.reference': 'Reference (optional)',
  'vat.filing.referencePh': 'For example the reference on the receipt from Skatteetaten',
  'vat.filing.comment': 'Comment (optional)',
  'vat.filing.lockNote': 'Once the period is marked as filed, the vouchers in it are locked. Changes must then be made as a correction.',
  'vat.filing.clearText': 'The period will then show as not filed in Plumme, and its vouchers are unlocked again. The change is logged with who and when. The status with Skatteetaten does not change.',
  'vat.filing.clearReason': 'Reason (optional)',
  'vat.filing.markedToast': 'The period is marked as filed outside Plumme',
  'vat.filing.clearedToast': 'Filed status removed',
  'vat.filing.failed': 'Could not update the VAT status.',
  'vat.filing.payAfterFiled': 'Available once the VAT return is filed with Skatteetaten and marked as filed here.',
  'vat.filing.markedOn': 'Marked in Plumme',
  'vat.filing.referenceLabel': 'Reference',
  'vat.filing.commentLabel': 'Comment',
  'vat.filing.statusNote': 'Plumme does not fetch the status from Skatteetaten. The status here is what has been marked in Plumme.',
  'vat.addComment': 'Add a comment',
  'vat.customs': 'Customs declaration',
  'vat.correctCustoms': 'Correct customs declaration',
  'vat.saveCustoms': 'Save customs declaration',
  'vat.fetchFromAltinn': 'Fetch from Altinn',
  'vat.fetchFromAltinnHelp': 'Fill in reference and customs basis automatically from filed declarations.',
  'vat.declarationRef': 'Declaration reference',
  'vat.declarationRefPh': 'Reference from customs',
  'vat.statisticalValue': 'Statistical value',
  'vat.vatCode': 'VAT code',
  'vat.attachments': 'Attachments / import trail',
  'vat.uploadAttachment': 'Upload attachment',
  'vat.attachmentHelp': 'Optional, but recommended for the audit trail and later import follow-up.',
  'vat.customsBasis': 'Customs basis',
  'vat.calculatedVat': 'Calculated VAT',
  'vat.deductible': 'Deductible',
  'vat.settlementDate': 'Settlement date',
  'vat.settlementType': 'Settlement type',
  'vat.useDueDate': 'Due date',
  'vat.useDueDateHelp': 'Set the settlement date to the VAT return due date',
  'vat.addSurcharges': 'Add interest/fee',
  'vat.surcharges': 'Interest and fee',
  'vat.removeSurcharges': 'Remove',
  'vat.lateInterest': 'Late-payment interest',
  'vat.lateInterestHelp': 'Posted as interest cost to 8150',
  'vat.penaltyFee': 'Fee or coercive fine',
  'vat.penaltyFeeHelp': 'Posted to 7799 and is not tax deductible',
  'vat.surchargeTotal': 'Charged to the account',
  'vat.surchargeNote': 'Interest and fees are not VAT. They are expensed and charged to the account, but do not change the VAT settlement for the period.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Pay VAT to the tax authority',
  'vat.payHelp': 'The account number and KID come from the tax authority once the return has been processed. Paying straight from the bank is not connected yet, so the payment is recorded in Plumme for now.',
  'vat.awaitingAuthority': 'Comes from the tax authority',
  'vat.pay': 'Pay',
  'vat.kidHelp': 'KID from the VAT return',
  'vat.authorityAccount': 'Skatteetaten account number',
  'vat.authorityAccountHelp': 'The Skatteetaten account number',
  'vat.notRegistered': 'The business is not set as VAT registered',
  'vat.view': 'View',
  'vat.viewHelp': 'Switch between "Periods" — one card per VAT period with status and deadline — and "Overview", which sums up what you owe, have paid and have refundable across the periods.',
  'vat.viewTerms': 'Periods',
  'vat.viewOverview': 'Overview',

  'vat.filing.notFiled': 'Not filed',
  'vat.filing.upcomingStatus': 'Upcoming',
  'vat.filing.importedArchive': 'Imported archive',
  'vat.vatReceivable': 'VAT refundable',
  'vat.vatToPay': 'VAT to pay',
  'vat.noVat': 'No VAT',
  'vat.noneWithWord': 'No {{word}}',
  'vat.manualUnsupported': '{{word}} on manual postings is not enabled for {{country}} yet',
  'vat.manual.input25': '1 - Input VAT 25 %',
  'vat.manual.input15': '11 - Input VAT 15 %',
  'vat.manual.input12': '13 - Input VAT 12 %',
  'vat.manual.output25': '3 - Output VAT 25 %',
  'vat.manual.output15': '31 - Output VAT 15 %',
  'vat.manual.output12': '33 - Output VAT 12 %',
  'vat.manual.reverseGoods25': '81 - Reverse charge, goods 25 %',
  'vat.manual.reverseServices25': '86 - Reverse charge, services 25 %',
  'vat.manual.importVatOnly25': '14 - Input VAT only 25 %',
  'vat.manual.importBasis25': '21 - Import basis 25 %',
  'vat.manual.importBasisZero': '23 - Import basis without VAT (SAF-T 20)',
  'vat.receivableShort': 'Refundable',
  'vat.remainingToPay': 'Remaining to pay',
  'vat.termLabel': '{n}. period {year}',
  'vat.noTermsHelp': 'Once the business is VAT registered, Plumme shows periods, deadlines and calculated VAT here.',
  'vat.youOwe': 'You owe',
  'vat.youAreOwed': 'You are owed',
  'vat.noVatToSettle': 'No VAT to settle',
  'vat.refund': 'Refund',
  'vat.paymentNoun': 'Payment',
  'vat.settlementNoun': 'Settlement',
  'vat.acctBankDeposit': 'Bank deposit',
  'vat.acctTaxDeductionAccount': 'Tax deduction account',
  'vat.acctCash': 'Cash',
  'vat.accountFallback': '{code} Account',
  'vat.settlementFullyRegistered': 'Fully registered',
  'vat.settlementPartiallyRegistered': 'Partially registered',
  'vat.settlementNotRegistered': 'Not registered',
  'vat.editRefund': 'Edit refund',
  'vat.editPayment': 'Edit payment',
  'vat.receivedOn': 'Received to',
  'vat.paidFrom': 'Paid from',
  'vat.noPaymentsHelp': 'Once you register a payment or refund for the period, it shows here.',
  'vat.addRefund': 'Add refund',
  'vat.addPayment': 'Add payment',
  'vat.cancelPaymentConfirmPrefix': 'Do you want to cancel the {kind} of',
  'vat.cancelPaymentConfirmDate': ' registered {date}',
  'vat.cancelPaymentConfirmSuffix': '? The amount is removed from the VAT period and cannot be retrieved.',
  'vat.overpaid': 'Overpaid',
  'vat.overrefunded': 'Overrefunded',
  'vat.remainingToReceive': 'Remaining to receive',
  'vat.registerSettlement': 'Register settlement',
  'vat.registerPayment': 'Register payment',
  'vat.registerRefund': 'Register refund',
  'vat.inYourFavor': 'in your favour',
  'vat.toTaxAuthority': 'to the tax authority',
  'vat.receivedBack': 'Received back',
  'vat.archiveCannotSettle': 'Imported history cannot be settled as a new Plumme period.',
  'vat.noVatToSettleForTerm': 'The period has no VAT to settle.',
  'vat.sourceImported': 'Imported',
  'vat.sourceManual': 'Registered manually',
  'vat.registerVatRefund': 'Register VAT refund',
  'vat.registerVatPayment': 'Register VAT payment',
  'vat.saveRefund': 'Save refund',
  'vat.savePayment': 'Save payment',
  'vat.remainingHint': 'Remaining {amount}',
  'vat.notRegisteredHelp': 'Once the business is set as VAT registered in settings, Plumme shows VAT periods, code overview and settlement here.',
  'vat.reviewReadyToast': 'The VAT return is ready for review',
  'vat.customsAltinnNotConnected': 'Altinn import for customs declarations is not connected yet.',
  'vat.selectAttachmentToUpload': 'Select an attachment to upload',
  'vat.customsDefaultDescription': 'Customs declaration',
  'vat.customsDateTermHint': 'The date must be within {period}.',
  'vat.customs81': '25% with deduction right',
  'vat.customs82': '25% without deduction right',
  'vat.customs83': '15% with deduction right',
  'vat.customs84': '15% without deduction right',
  'vat.customs85': '0% import',
  'vat.customsSaved': 'Customs declaration saved',
  'vat.customsSaveFailed': 'Could not save the customs declaration.',
  'vat.customsDeleted': 'Customs declaration deleted',
  'vat.customsDeleteFailed': 'Could not delete the customs declaration.',
  'vat.refundSaved': 'Refund saved',
  'vat.paymentSaved': 'Payment saved',
  'vat.paymentSaveFailed': 'Could not save the payment.',
  'vat.refundCancelled': 'Refund cancelled',
  'vat.paymentCancelled': 'Payment cancelled',
  'vat.paymentCancelFailed': 'Could not cancel the payment.',

  'vat.supplierSearch': 'Search or add a supplier...',
  'vat.supplierClose': 'Close supplier selection',
  'vat.supplierNone': 'No suppliers found.',
  'vat.supplierNew': 'New supplier',
  'vat.supplierName': 'Name',
  'vat.supplierOrg': 'Company no.',
  'vat.supplierEmail': 'Email',
  'vat.supplierPhone': 'Phone',

  // ---------------------------------------------------------- Fixed assets
  // ---------------------------------------- Fixed assets: register, editor, detail

  'vat.customsPostingExplanation': 'Use the customs declaration amounts. Non-deductible VAT must be posted to the appropriate expense or asset account.',
  'vat.nonDeductibleAccount': 'Account for non-deductible VAT',
  'vat.nonDeductibleAccountHelp': 'Enter the expense or asset account used for the acquisition. An account is required before posting.',

  // --------------------------------------- Transactions list, inbox status, paid-purchase flow
  'voucherList.titleHelp': 'A voucher is the documentation behind a posting: an invoice, a receipt, another sale, a customs declaration or a free posting. Here you see the vouchers fetched from the backend for the selected financial year.',
  'voucherList.backToTrialBalance': 'Back to the trial balance',
  'voucherList.backToIncomeStatement': 'Back to the income statement',
  'voucherList.accountBadge': 'Account {number} · {name}',
  'voucherList.vatCodeBadge': 'VAT code {code}',
  'voucherList.viewOptions': 'View options',
  'voucherList.noneForVatCode': 'No vouchers found for VAT code {code} in the selected period.',
  'voucherList.noneForAccount': 'No vouchers posted to {number} {name} in {year}.',
  'voucherList.noneMatchSearch': 'No vouchers match the search.',
  'voucherList.noneInView': 'No vouchers match this view.',
  'voucherList.ledgerLinesMissing': 'The vouchers have no posting lines from the backend.',
  'voucherList.debit': 'Debit',
  'voucherList.credit': 'Credit',
  'voucherList.colVoucher': 'Voucher',
  'voucherList.colNumber': 'Voucher no.',
  'voucherList.colDate': 'Date',
  'voucherList.inlineVat': 'VAT',
  'voucherList.kindInvoice': 'Invoice',
  'voucherList.kindSupplier': 'Supplier',
  'voucherList.kindCreditNote': 'Credit note',
  'voucherList.kindManual': 'Manual voucher',
  'voucherList.kindPurchase': 'Purchase',
  'voucherList.kindOtherSale': 'Other sale',
  'voucherList.kindMileage': 'Mileage log',
  'voucherList.kindCustoms': 'Customs declaration',
  'voucherList.kindCustomsCorrection': 'Customs declaration period correction',
  'voucherList.kindBankPosting': 'Bank posting',
  'voucherList.kindPayment': 'Payment',
  'voucherList.kindPayroll': 'Payroll',
  'voucherList.kindPayrollPayment': 'Payroll payment',
  'voucherList.kindReversal': 'Reversal',
  'voucherList.kindPublicFees': 'Public taxes and fees',
  'voucherList.kindAssetDisposal': 'Asset disposal',
  'voucherList.kindYearEnd': 'Year-end closing',
  'voucherList.kindQuote': 'Quote',
  'voucherList.kindOrderConfirmation': 'Order confirmation',
  'voucherList.filterSales': 'Sales',
  'voucherList.filterSupplierInvoice': 'Supplier invoice',
  'voucherList.filterFreePosting': 'Free posting',
  'voucherList.missingAttachment': 'Missing attachment',
  'voucherList.hasAttachment': 'Has attachment',
  'voucherList.unpaid': 'Unpaid',
  'voucherList.showAnnulled': 'Show annulled',
  'voucherList.hidePayments': 'Hide payments',
  'voucherList.includeAnnulled': 'Include annulled',
  'vat.amountOnly': 'VAT amount only',
  'voucherList.onlyAnnulled': 'Show annulled only',
  'voucherList.paid': 'Paid',
  'voucherList.partiallyPaid': 'Partially paid',
  'voucherList.annulled': 'Annulled',
  'voucherList.attachmentLost': 'Voucher lost',
  'voucherList.openInvoiceList': 'View in invoice list',
  'voucherList.editSale': 'Edit sale',
  'voucherList.openInBank': 'Open in bank',
  'voucherList.editPosting': 'Edit posting',
  'voucherList.correctPosting': 'Correct voucher',
  'voucherList.editMileage': 'Edit mileage log',
  'voucherList.openInVat': 'Open in VAT',
  'voucherList.edit': 'Edit',
  'voucherList.purchaseNotFound': 'Could not find the purchase to edit. Try refreshing the page and opening the voucher again.',
  'voucherList.saleNotFound': 'Could not find the sale to edit. Try refreshing the page and opening the voucher again.',
  'inboxStatus.alreadyBooked': 'Already posted?',
  'inboxStatus.booked': 'Posted',
  'inboxStatus.inTrash': 'In trash',
  'inboxStatus.readyToBook': 'Ready to post',
  'inboxStatus.needsReview': 'Needs review',
  'inboxStatus.analysisFailed': 'Analysis failed',
  'inboxStatus.analyzing': 'Analysing',
  'inboxStatus.awaitingAnalysis': 'Awaiting analysis',
  'inboxStatus.show': 'Show',
  'inboxStatus.hide': 'Hide',
  'inboxStatus.dropReceipts': 'Drop the receipts here',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma reads what it can',
  'inboxStatus.dropDocuments': 'Drop the documents here',
  'inboxStatus.dropDocumentsHint': 'Added to Documentation',
  'inboxStatus.bookWithSuperPlumma': 'Post with SuperPlumma',
  'inboxStatus.saving': 'Saving...',
  'purchaseFlow.stepReceipt': 'Receipt',
  'purchaseFlow.stepDetails': 'Details',
  'purchaseFlow.stepLines': 'Lines',
  'purchaseFlow.stepPreview': 'Preview',
  'purchaseFlow.typeRegular': 'Paid purchase',
  'purchaseFlow.typeInvoice': 'Supplier invoice',
  'purchaseFlow.typeDrafts': 'Drafts',
  'purchaseFlow.receivedReading': 'Receipt received - SuperPlumma is reading it now',
  'purchaseFlow.receivedReadingMany': '{count} receipts received - SuperPlumma is reading them now',
  'purchaseFlow.prefilled': 'SuperPlumma filled in what it could read from the receipt. Check before posting.',
  'purchaseFlow.amountReview': 'Amounts and VAT could not be filled in reliably. Check the receipt and enter the net amount and correct VAT treatment for each line before posting.',
  'purchaseFlow.analysisFailed': 'The receipt was uploaded, but the analysis failed.',
  'purchaseFlow.inboxResolveFailed': 'The entry is saved, but the receipt was not removed from the inbox. Mark it as posted there.',
  'purchaseFlow.receiptFallbackName': 'Receipt',
});
